import { useState } from "react";
import React from "react";
import { Form, Button, Container } from "react-bootstrap";
import './contact.css';


const Contact = () => {
    const [input, setInput] = useState({
        firtsName: '',
        lastName: '',
        email: '',
        message: '',
    })
    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(input)

    }
    const handleChange = (e) => {
        setInput({
            ...input,
            [e.target.name]: e.target.value
        });
        console.log(e.target.name, ' ' + e.target.value);
        
    };

    return (
        <Container className="registerLoginContainer">
            {/* <div className=""> */}
                <div className="">
                    <h1>Contacto</h1>
                    <p className="texto">Por favor, completa el formulario para enviarnos un mensaje</p>
                    <Form className="login" onSubmit={handleSubmit}>
                        <Form.Group className="form-group">
                            <Form.Label className="tituloForm1"></Form.Label>
                            <i className="far fa-user icon-modificado"></i>
                            <Form.Control
                                type="text"
                                name="firstName"
                                value={input.firtsName}
                                placeholder="Nombre"
                                onChange={handleChange}
                                className="label-input"
                            />
                        </Form.Group>
                        <Form.Group className="form-group">

                            <Form.Control
                                type="text"
                                name="lastName"
                                value={input.lastName}
                                placeholder="Apellido"
                                onChange={handleChange}
                                className="label-input"
                            />
                        </Form.Group>
                        <Form.Group className="form-group">

                            <Form.Control
                                type="email"
                                name="email"
                                value={input.email}
                                placeholder="Email"
                                onChange={handleChange}
                                className="label-input"
                            />
                        </Form.Group>
                        <Form.Group className="form-group">

                            <Form.Control
                                type="textarea"
                                rows={6}
                                name="message"
                                value={input.message}
                                placeholder="Escribe tu consulta aqui"
                                onChange={handleChange}
                                className="message-input"

                            />
                        </Form.Group>
                        <div className="button-container">
                            <Button className="btn3 button" variant="primary" type="submit" >
                                Enviar
                            </Button>
                        </div>

                    </Form>
                </div>
            {/* </div> */}
        </Container>


    )
}

export default Contact;